import { LogoStrip } from '../components/LogoStrip';
import { SectionWrapper } from '../components/SectionWrapper';

import styles from './ProofStripSection.module.css';

const logos = [
  { name: 'UCLA' },
  { name: 'UC San Diego' },
  { name: 'Cal State' },
  { name: 'OpenStax (Official Partner)' },
] as const;

const credibilityLines = [
  {
    text: "Validated by UCLA's Center for Education Innovation and Learning in the Sciences",
  },
  { href: '/research', text: 'Published in Physical Review Physics Education Research (2025)' },
  {
    accent: 'amber',
    href: '/research',
    text: 'Official partner of OpenStax',
  },
] as const;

export function ProofStripSection() {
  return (
    <SectionWrapper data-testid="marketing-section-proof-strip">
      <div className={styles.section}>
        <LogoStrip
          credibilityLines={[...credibilityLines]}
          eyebrow="Used at"
          logos={[...logos]}
        />
      </div>
    </SectionWrapper>
  );
}
